import React from 'react';
import { Badge } from '../ui/badge';

interface DomainStatusBadgeProps {
  status: 'pending' | 'active' | 'error';
}

export const DomainStatusBadge: React.FC<DomainStatusBadgeProps> = ({ status }) => {
  const statusConfig = {
    pending: {
      label: 'Pending Verification',
      variant: 'secondary' as const,
      className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    },
    active: {
      label: 'Active',
      variant: 'default' as const,
      className: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    },
    error: {
      label: 'Configuration Error',
      variant: 'destructive' as const,
      className: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    },
  };

  const config = statusConfig[status];

  return (
    <Badge variant={config.variant} className={config.className}>
      {config.label}
    </Badge>
  );
};
